import React from 'react'
import { Switch } from 'react-router-dom'
import Route from '../utils/Route'
import { getInternalRoutes } from '@/internal-app/route-config'

const routes = getInternalRoutes()

export default () => {
  return <Switch>
    {routes.map((route, i) => <Route {...route} key={i} />)}
  </Switch>
}



// WEBPACK FOOTER //
// ./src/internal-app/routes.js